const { isTopLevelContext } = require('../identity/context');

let installed = false;

/**
 * Mounts the Shows widget above The Feed on the RebelMouse homepages (Narcity,
 * MTL Blog and Narcity Québec at /fr/), with no CMS markup. The Feed heading
 * block directly precedes the `.container.feed` river; other section, city and
 * article pages are excluded. The widget loads lazily, honours the
 * server placement flag and removes itself when the placement has no clips.
 */
function setupHomepageShows(api, options) {
  if (installed) return;
  installed = true;
  const run = () => {
    // Narcity Québec's homepage is the `fr` section page; French articles share its body class.
    const homepage = document.body && (document.body.classList.contains('section-frontpage') || /^\/fr\/?$/.test(location.pathname));
    const feed = homepage && document.querySelector('.container.feed');
    const title = feed && feed.previousElementSibling;
    if (!title || !title.classList.contains('section__title') || !isTopLevelContext()) return;
    // Inside the heading block: its full content width (not the narrower feed
    // column), and section-title modules such as the newsletter stay above it.
    const target = document.createElement('div');
    target.className = 'milla-shows-homepage';
    title.prepend(target);
    api.mountShows({ target, publication: options.brand, placementId: 'homepage-shows', hideWhenEmpty: true,
      language: /^fr/i.test(document.documentElement.lang) ? 'fr' : 'en' }).ready.then((shown) => { if (!shown) target.remove(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
}

module.exports = { setupHomepageShows };
